import React from 'react';
import { money } from './money';

export default function KpiCard({
  label,
  value,
  caption,
  tone = 'text-gray-900',
  moneyValue = false,
}) {
  const displayValue = moneyValue ? money(value) : value;
  return (
    <div className="min-w-0 border-r border-gray-100 px-3 py-2 last:border-r-0">
      <p className="truncate text-[11px] font-semibold uppercase tracking-widest text-gray-400">
        {label}
      </p>
      <p className={`mt-1 truncate text-sm font-semibold tabular-nums ${moneyValue && Number(value) < 0 ? 'text-red-700' : tone}`}>
        {displayValue}
      </p>
      {caption && (
        <p className="mt-0.5 truncate text-xs text-gray-500">{caption}</p>
      )}
    </div>
  );
}
